export default __webpack_public_path__ + "static/media/calidades.23c59e44.png";